import { Flex, FormControl, FormLabel, Heading } from "@chakra-ui/react";
import { FormikProps } from "formik";
import { MultiSelectInput } from "src/components/Inputs/MultiSelectInput";
import { FormEngineRuleFormData } from "src/scenes/orgAdmin/formTemplates/RulesTab/FormEngineRuleDrawer/schemas";
import { TagType } from "src/scenes/orgAdmin/formTemplates/RulesTab/FormEngineRuleDrawer/shared";
import { useFieldError } from "../context";

export type SelectTagsProps = {
  formik: FormikProps<FormEngineRuleFormData>;
  tags: TagType[];
};

export const SelectTags: React.FC<SelectTagsProps> = ({ tags, formik }) => {
  const tagIdsError = useFieldError("tag_ids");

  return (
    <Flex direction="column" gap="0.5rem" p="1rem">
      <Heading as="h4" size="sm">
        What would you like to do?
      </Heading>
      <FormControl isInvalid={tagIdsError !== undefined}>
        <FormLabel pb="0.5rem" m="0">
          Which tags do you want to work with?
        </FormLabel>
        <MultiSelectInput
          size="md"
          options={tags
            .sort((a, b) => {
              const aGroup = a.tag_group?.name || "Ungrouped";
              const bGroup = b.tag_group?.name || "Ungrouped";
              if (aGroup === bGroup) {
                return a.name.localeCompare(b.name);
              }
              return aGroup.localeCompare(bGroup);
            })
            .map((tag) => ({
              id: tag.id,
              label: tag.name,
              group: tag.tag_group?.name || "Ungrouped",
            }))}
          initialValues={formik.values.tag_ids.map((tagId) => {
            const tag = tags.find((t) => t.id === tagId);
            return {
              id: tagId,
              label: tag ? tag.name : tagId,
              group: tag?.tag_group?.name || "Ungrouped",
            };
          })}
          onChange={(selectedTags) => {
            formik.setFieldValue(
              "tag_ids",
              selectedTags.map((t) => t.id)
            );
          }}
          placeholder="Select tags"
          renderDropdownItem={(item) => <Flex key={item.id}>{item.label}</Flex>}
          error={tagIdsError}
        />
      </FormControl>
    </Flex>
  );
};
